export const fiscalReport = {
	title: "Relatório fiscal",
	activeTab: "relatorio-fiscal",
	period: "Período",
	errorNotification: "Data limite {{date}}",
	sheet: {
		title: "Relatório Fiscal",
		filename: "relatório_fiscal",
		columns: {
			date: "Data",
			eventName: "Evento",
			totalReceipt: "Faturamento emissível",
			emitted: "Faturamento emitido",
			emittedNfce: "Notas de consumo",
			emittedNfse: "Notas de serviço",
		},
	},
	fiscalProfile: "Perfil fiscal",
	columns: {
		date: "Data",
		eventName: "Evento",
		totalReceipt: "Faturamento emissível",
		emitted: "Faturamento emitido",
		emittedNfce: "Notas de consumo",
		emittedNfse: "NOtas de serviço",
		total: "Total",
	},
};
